import sharedLabel from '../../../translation'
import type {ILabel} from '../../../../../types'

export default {
    productName: <ILabel>{
        de: 'Name',
        en: 'Name',
        es: 'Nombre',
        fr: 'Nom',
        nl: 'Naam',
        it: 'Nome',
    },
    productId: sharedLabel.articleNumber,
    productSize: <ILabel>{
        de: 'Abmessungen',
        en: 'Measurements',
        es: 'Medidas',
        fr: 'Dimensions',
        nl: 'Afmetingen',
        it: 'Misure',
    },
    productCaratSum: <ILabel>{
        de: 'Karatgewicht Summe',
        en: 'Carat Weight Sum',
        es: 'Sume del peso en quilates',
        fr: 'Poids total en carat',
        nl: 'Karaatgewicht som',
        it: 'Somma del peso in carati',
    },
    productMetal: sharedLabel.material,
    productAlloy: <ILabel>{
        de: 'Legierung',
        en: 'Alloy',
        es: 'Aleación',
        fr: 'Alliage',
        nl: 'Legering',
        it: 'Tipo di metallo',
    },
    productMetalWeight: <ILabel>{
        de: 'Metallgewicht',
        en: 'Metal Weight',
        es: 'Peso del metal',
        fr: 'Poids du métal précieux',
        nl: 'Metaalgewicht',
        it: 'Peso Metallo',
    },
    productDesign: <ILabel>{
        de: 'Design',
        en: 'Design',
        es: 'Diseño',
        fr: 'Design',
        nl: 'Ontwerp',
        it: 'Design',
    },
    gemStone: (position: number) : ILabel => {
        if(position === 1) {
            return {
                de: 'Erster Edelstein',
                en: 'First Gemstone',
                es: 'Piedra preciosa principal',
                fr: 'Pierre principale',
                nl: 'Hoofd edelsteen',
                it: 'Pietre principali',
            }
        }
        if(position === 2) {
            return {
                de: 'Zweiter Edelstein',
                en: 'Second Gemstone',
                es: 'Segunda piedra preciosa',
                fr: '2ème pierre',
                nl: 'Tweede edelsteen',
                it: 'Seconda pietra preziosa',
            }
        }
        if(position === 3) {
            return {
                de: 'Dritter Edelstein',
                en: 'Third Gemstone',
                es: 'Tercera piedra preciosa',
                fr: '3ème pierre',
                nl: 'Derde edelsteen',
                it: 'Terza pietra preziosa',
            }
        }
        if(position === 4) {
            return {
                de: 'Vierter Edelstein',
                en: 'Fourth Gemstone',
                es: 'Cuarta piedra preciosa',
                fr: '4ème pierre',
                nl: 'Vierde edelsteen',
                it: 'Quarta pietra preziosa',
            }
        }
        if(position === 5) {
            return {
                de: 'Fünfter Edelstein',
                en: 'Fifth Gemstone',
                es: 'Quinta piedra preciosa',
                fr: '5ème pierre',
                nl: 'Vijfde edelsteen',
                it: 'Quinta pietra preziosa',
            }
        }
        if(position === 6) {
            return {
                de: 'Sechster Edelstein',
                en: 'Sixth Gemstone',
                es: 'Sexta piedra preciosa',
                fr: '6ème pierre',
                nl: 'Zesde edelsteen',
                it: 'Sesta pietra preziosa',
            }
        }
        return {
            de: position+'. Edelstein',
            en: 'Gem '+position,
            es: position+'. piedra preciosa',
            fr: position+'ème pierre',
            nl: position+'. edelsteen',
            it: position+'. pietra preziosa',
        }
    },
    gemName: <ILabel>{
        de: 'Varietät',
        en: 'Variety',
        es: 'Nombre exacto de la piedra preciosa',
        fr: 'Dénomination exacte',
        nl: 'Edelsteen exact',
        it: 'Varietà',
    },
    gemCount: <ILabel>{
        de: 'Anzahl',
        en: 'Quantity',
        es: 'Cantidad',
        fr: 'Quantité',
        nl: 'Aantal',
        it: 'Quantitá',
    },
    gemColor: <ILabel>{
        de: 'Edelsteinfarbe',
        en: 'Gemstone Colour',
        es: 'Color de la piedra',
        fr: 'Couleur de la pierre',
        nl: 'Edelsteen kleur',
        it: 'Colore delle gemme',
    },
    gemCarat: <ILabel>{
        de: 'Karatgewicht',
        en: 'Carat weight',
        es: 'Peso en quilates',
        fr: 'Poids en carat',
        nl: 'Karaatgewicht',
        it: 'Peso in carati',
    },
    gemSize: <ILabel>{
        de: 'Größe',
        en: 'Size',
        es: 'Tamaño',
        fr: 'Taille',
        nl: 'Grote',
        it: 'Dimensione',
    },
    gemCut: <ILabel>{
        de: 'Schliff',
        en: 'Cut',
        es: 'Talla',
        fr: 'Taille de la pierre',
        nl: 'Slijpvorm',
        it: 'Taglio',
    },
    gemSetting: <ILabel>{
        de: 'Fassung',
        en: 'Setting',
        es: 'Agarre',
        fr: 'Sertissage',
        nl: 'Zetting',
        it: 'Incastonatura',
    },
    gemOrigin: <ILabel>{
        de: 'Herkunft',
        en: 'Origin',
        es: 'Extracción',
        fr: 'Origine',
        nl: 'Herkomst',
        it: 'Estrazione',
    },
}